import React from 'react'

const TypeSelector = ({
	destinationType,
	setDestinationType,
	labels,
	styles,
	isDarkMode,
}) => {
	// Common focus styles for consistent appearance
	const focusRingClass =
		'focus:ring focus:ring-opacity-50 focus:border-blue-300 focus:ring-blue-200'

	return (
		<div
			className="type-select select-wrap"
			style={{ width: '100px' }}
		>
			<label
				style={{
					...labels,
					backgroundColor: isDarkMode ? '#1c2126' : '#ffffff',
					color: isDarkMode ? '#C9D1D9' : '#3a4353',
				}}
			>
				Type
			</label>
			<select
				value={destinationType}
				onChange={e => setDestinationType(e.target.value)}
				className={`border join-item mt-1 py-2 pl-3 h-[40px] w-full text-[13px] ${focusRingClass} ${
					isDarkMode
						? 'bg-gray-800 border-gray-600 text-white'
						: 'bg-white border-gray-300 text-gray-900'
				}`}
				style={{
					...styles,
					borderTopLeftRadius: '6px',
					borderBottomLeftRadius: '6px',
					borderTopRightRadius: '0',
					borderBottomRightRadius: '0',
				}}
			>
				<option value="CITY">City</option>
				<option value="STATE">State</option>
				<option value="REGION">Region</option>
			</select>
		</div>
	)
}

export default TypeSelector
